import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Stepper,
  Step,
  StepButton,
  Button,
  Container,
  Snackbar
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { Send as SendIcon } from "@material-ui/icons";

import AssetUploaderManager from "../AssetUploader/UploadStep/AssetUploaderManager";
import AssetOptions from "../AssetUploader/OptionsStep/AssetOptions";
import AssetNaming from "../AssetUploader/NamingStep/AssetNaming";
import AssetReview from "../AssetUploader/ReviewStep/AssetReview";
import Confirmation from "../Shared/Confirmation/Confirmation";

import { useSelector } from "react-redux";

import { insertCreatives } from "../../services/dcm/creatives";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%"
  },
  backButton: {
    marginRight: theme.spacing(1)
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  stepper: {
    margin: "20px auto 30px",
    width: "60%",
    paddingTop: 0
  }
}));

const next = {
  float: "right"
};

function getSteps() {
  return ["Upload creative(s)", "Generate name(s)", "Select options", "Review"];
}

const creativeTypes = ["INSTREAM_VIDEO"];

function getStepContent(stepIndex, props) {
  switch (stepIndex) {
    case 0:
      return (
        <div>
          <AssetUploaderManager
            creativeTypes={creativeTypes}
            isThumbnailEnabled={false}
            selectedCreatives={props.selectedCreatives}
            setSelectedCreatives={props.setSelectedCreatives}
            placements={props.placements}
            filetype={"video/*"}
            ref={(r) => (props.stepRef.current = r)}
          />
        </div>
      );
    case 1:
      return (
        <div>
          <AssetNaming
            isClickEnabled={true}
            isDragDisabled={true}
            isThumbnailEnabled={false}
            ref={(r) => (props.stepRef.current = r)}
          />
        </div>
      );
    case 2:
      return (
        <div>
          <AssetOptions
            isClickEnabled={false}
            isDragDisabled={false}
            isThumbnailEnabled={false}
            ref={(r) => (props.stepRef.current = r)}
          />
        </div>
      );
    case 3:
      return (
        <div>
          <AssetReview
            isClickEnabled={false}
            isDragDisabled={true}
            isThumbnailEnabled={false}
            ref={(r) => (props.stepRef.current = r)}
          />
        </div>
      );
    default:
      return " ";
  }
}

export default () => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState(new Set());
  const [skipped, setSkipped] = React.useState(new Set());
  const creativesState = useSelector((state) => state.creatives);
  const steps = getSteps();

  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [selectedCreatives, setSelectedCreatives] = React.useState([]);

  const stepRef = useRef();

  const history = useHistory();

  useEffect(() => {
    if (creativesState.assignedPlacements.length < 1) {
      history.push("/");
    }
  }, [creativesState.assignedPlacements.length, history]);

  const handleNext = () => {
    if (
      stepRef &&
      stepRef.current &&
      stepRef.current.hasOwnProperty("validate")
    ) {
      const validation = stepRef.current.validate();

      if (validation.hasErrors) {
        if (validation.message) {
          setSnackbarMessage(validation.message);
          setSnackbarOpen(true);
        }

        return;
      }
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  function isStepComplete(step) {
    return completed.has(step);
  }

  const handleTraffic = () => {
    insertCreatives(
      Object.values(creativesState.byId),
      creativesState.assignedPlacements,
      "DISPLAY"
    );
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  return (
    <div className={classes.root}>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        nonLinear
        className={classes.stepper}
      >
        {steps.map((label, index) => {
          const stepProps = {};
          const buttonProps = {};
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label} {...stepProps}>
              <StepButton
                onClick={handleStep(index)}
                completed={isStepComplete(index)}
                {...buttonProps}
              >
                {label}
              </StepButton>
            </Step>
          );
        })}
      </Stepper>
      <Container maxWidth="lg">
        <div>
          {activeStep === steps.length ? (
            <Confirmation handleReset={handleReset} />
          ) : (
            <div>
              <div style={next}>
                <Button
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  className={classes.button}
                  disableElevation
                >
                  Back
                </Button>
                {activeStep === steps.length - 1 ? (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleTraffic}
                    startIcon={<SendIcon />}
                    disableElevation
                  >
                    Submit Placements
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    disableElevation
                  >
                    Next
                  </Button>
                )}
              </div>
              {getStepContent(activeStep, {
                stepRef,
                selectedCreatives,
                setSelectedCreatives,
                placements: creativesState.assignedPlacements
              })}
            </div>
          )}
        </div>
      </Container>
      <Snackbar
        autoHideDuration={3000}
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
      >
        <MuiAlert onClose={() => setSnackbarOpen(false)} severity="warning">
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};
